import React from 'react';
import { shape, string } from 'prop-types';
import TextBox from '@components/TextBox/TextBox';

import Css from './Mobile.scss';
import ImportImages from '@src/importImages';

const clouds = ImportImages('/home/clouds.jpg');
const cockpitEmpty = ImportImages('/safety/cockpit-empty.jpg');

const propTypes = {
  id: string.isRequired,
  technologyProps: shape({
    header: string.isRequired,
    content: string.isRequired
  }).isRequired
};

const mobileStyles = {
  minHeight: `${window.innerHeight}px`,
  backgroundImage: `url(${clouds})`,
  backgroundPosition: 'center center',
  backgroundSize: '100% 100%',
  paddingBottom: '2rem'
};

const textBoxStyles = {
  backgroundColor: 'white',
  opacity: '0.7',
  fontSize: '16px',
  margin: '8rem 1.5rem 1.5rem'
};

const Mobile = ({ id, technologyProps }) => (
  <div
    id={id}
    className={`${Css['technology-mobile']} panel`}
    style={mobileStyles}
  >
    <TextBox {...technologyProps} style={textBoxStyles} />
    <div className={Css['technology-img-wrapper']}>
      <img src={cockpitEmpty} alt={'Technology'} className={`img-fluid`} />
    </div>
  </div>
);

Mobile.propTypes = propTypes;

export default Mobile;



// WEBPACK FOOTER //
// ./src/components/Safety/Technology/Mobile/Mobile.jsx